import { Container, Row, Col } from "react-bootstrap";
import { FaPhoneAlt, FaWhatsapp, FaGithub, FaLinkedinIn, FaGlobe } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { BiSolidDownload } from "react-icons/bi";
import aboutImage from "../../Assets/sanjeet.png";
import Particle from "../Particle";

function BusinessCard() {
  // Function to create VCF file
  const createVCard = () => {
    const vCard = `BEGIN:VCARD
VERSION:3.0
FN:Sanjeet Pathak
TITLE:Senior Tech Consultant
ORG:IzzkiTech Solutions
TEL:+917903003794
EMAIL:hello@sanjeetpathak.com
URL:https://sanjeetpathak.com
END:VCARD`;

    const blob = new Blob([vCard], { type: "text/vcard" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'sanjeet_pathak.vcf');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row className="justify-content-center">
          <Col md={8} className="business-card">
            <div className="card-content">
              <div className="blob-container mb-4">
                <div className="blob" style={{ width: "200px", height: "200px" }}>
                  <img
                    src={aboutImage}
                    alt="Sanjeet Pathak"
                    className="img-fluid"
                  />
                </div>
              </div>
              
              <h1 className="text-center mb-4">
                <strong className="purple">Sanjeet Pathak</strong>
              </h1>
              
              <h2 className="text-center mb-4" style={{ fontSize: "1.5em", color: "white" }}>
                Senior Tech Consultant | Solution Architect
              </h2>
              
              <div className="contact-buttons">
                <a
                  href="tel:+917903003794"
                  className="contact-button"
                  aria-label="Call"
                >
                  <FaPhoneAlt /> Call
                </a>
                
                <a
                  href="https://wa.me/917903003794"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-button"
                  aria-label="WhatsApp"
                >
                  <FaWhatsapp /> WhatsApp
                </a>
                
                <a
                  href="mailto:hello@sanjeetpathak.com"
                  className="contact-button"
                  aria-label="Email"
                >
                  <MdEmail /> Email
                </a>
                  <button
                  onClick={createVCard}
                  className="contact-button"
                  aria-label="Save Contact"
                >
                  <BiSolidDownload /> Save Contact
                </button>
              </div>

              <div className="social-links-card">
                <a
                  href="https://github.com/Sanjeet990"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-button"
                  aria-label="GitHub Profile"
                >
                  <FaGithub /> GitHub
                </a>
                
                <a
                  href="https://www.linkedin.com/in/sanjeet-pathak/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-button"
                  aria-label="LinkedIn Profile"
                >
                  <FaLinkedinIn /> LinkedIn
                </a>
                
                <a
                  href="https://sanjeetpathak.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-button"
                  aria-label="Personal Website"
                >
                  <FaGlobe /> Website
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default BusinessCard;
